import { refreshTokens } from '@/utils';
import { BaseQueryApi, FetchArgs,  fetchBaseQuery } from '@reduxjs/toolkit/query';
import { AuthType, Roles } from '@/utils/types';
import { BASE_URL } from '@/utils/constants';
import { login, logout } from '@/store/slices/auth.slice';


const getToken = (state: any, key: 'accessToken' | 'refreshToken') => {
    const { user } = state.auth;
    return user && user[key];
};

const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState, endpoint }: any) => {
        const token = getToken(getState(), 'accessToken');
        const refreshToken = getToken(getState(), 'refreshToken');
        if (token) {
            headers.set('Authorization', `Bearer ${endpoint.includes('refresh') ? refreshToken : token}`);
        }
        return headers;
    },
});

const generalBaseQuery = async (args: FetchArgs, api: BaseQueryApi, extraOptions: any = {}) => {
    let result = await baseQuery(args, api, extraOptions);
    if (result.error && result.error.status === 401) {
        try {
            const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : null;
            if (!user) throw new Error();
            const refreshToken = user.refreshToken;
            if (refreshToken) {
                const newTokens = await refreshTokens(refreshToken, user.role === Roles.Coordinator ? AuthType.Coordinator : AuthType.Admin);
                api.dispatch(login(newTokens));
                extraOptions.headers = {
                    ...extraOptions.headers,
                    Authorization: `Bearer ${newTokens.accessToken}`,
                };
                result = await baseQuery(args, api, extraOptions);
            }
        } catch (error) {
            api.dispatch(logout());
        }
    }

    return result;
};

export default generalBaseQuery
